export const findMiddle = (num1: number, num2: number, rounded = false) =>
	rounded ? Math.round((num1 + num2) / 2) : Number(((num1 + num2) / 2).toFixed(6))
